/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Tooltip } from '@mui/material';
import React, { useRef, useState, useCallback, useEffect } from 'react';
import PDFExportPanel from '../../../../../../SharedModules/pdfExport/PDFExportPanel';
import Grid from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import TabNDCDetailDescriptionComponent from './TabNDCDetailDescriptionComponent';

const TabNDCDetailsTableComponent = ({
  tableData,
  tableHead,
  label,
  fullScreenView,
  setFullScreenView,
}) => {
  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    gridApi && gridApi.setFilterModel(null);
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, tableData]);

  return (
    <div className="table-container eightRecords mt-3 col-12">
      <Grid
        gridHeight={fullScreenView ? '100vh' : null}
        rowData={tableData}
        noRowPadding={true}
        fullScreenView={fullScreenView}
        applyFilter={false}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile={true}
        fileName="PRICE"
        ref={childRef}
        onGridReady={onGridReady}
        defaultCol={{ editable: false }}
        columnDefs={tableHead}
        cellClickedListener={(e) => {}}
        frameworkComponents={{
          customDescription: TabNDCDetailDescriptionComponent,
        }}
        onFilterChanged={() => setTableCount(gridApi.getDisplayedRowCount())}
      />
      {/* <p className='total-results'>
        Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
      </p> */}
    </div>
  );
};

export default TabNDCDetailsTableComponent;
